/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_Preset_MonthInputs */

const cs_dashboard_period_preset_month = /** @type {(inputs: Dashboard_Period_Preset_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento měsíc`)
};

const en_dashboard_period_preset_month = /** @type {(inputs: Dashboard_Period_Preset_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month`)
};

/**
* | output |
* | --- |
* | "This month" |
*
* @param {Dashboard_Period_Preset_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_preset_month = /** @type {((inputs?: Dashboard_Period_Preset_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_Preset_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_preset_month(inputs)
	return cs_dashboard_period_preset_month(inputs)
});